import {
  CarouselItem,
  HotspotItem
} from 'content/models/LessonComponentContent';
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable
} from 'react-beautiful-dnd';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Grid from '@mui/material/Unstable_Grid2';
import { IconButtonWithConfirmation } from '../../../shared/components/IconButtonWithConfirmation';
import LessonComponentService from '../../services/LessonComponentService';
import React from 'react';
import { styled } from '@mui/system';
import styles from '../../styles/ItemList.module.css';

interface ItemListProps {
  items: HotspotItem[] | CarouselItem[];
  onDragEnd: (result: DropResult) => void;
  onDelete: (id: string) => void;
}

const DroppableDiv = styled('div')(({ theme }) => ({
  '&[data-over="true"]': {
    background: '#eee',
    paddingBottom: '27px'
  }
}));

export default function ItemList(props: ItemListProps) {
  const { items } = props;

  return (
    <div className={`${styles.itemContainer}`}>
      <DragDropContext onDragEnd={props.onDragEnd}>
        <Droppable droppableId="itemId">
          {(dropProvided, dropSnapshot) => (
            <DroppableDiv
              ref={dropProvided.innerRef}
              data-over={dropSnapshot.isDraggingOver}
            >
              {items?.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(dragProvided, dragSnapshot) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                    >
                      <Grid container alignItems="center">
                        <Grid
                          {...dragProvided.dragHandleProps}
                          style={{ padding: '5px 5px 0px 0px' }}
                        >
                          <span
                            style={{
                              color: 'rgba(0,0,0,0.54)' //* to make it look the same as the 'delete' icon button
                            }}
                          >
                            <DragIndicatorIcon />
                          </span>
                        </Grid>
                        <Grid style={{ flex: 1 }}>
                          <span
                            className={`${styles.itemHeading} ${
                              !LessonComponentService.getFilteredContent(
                                item.heading
                              ) && styles.noHeading
                            }`}
                            dangerouslySetInnerHTML={{
                              __html: `${index + 1}. ${
                                LessonComponentService.getUrlWithSas(
                                  LessonComponentService.getFilteredContent(
                                    item.heading
                                  )
                                )
                                  ? item.heading
                                  : 'No title'
                              }`
                            }}
                          ></span>
                        </Grid>
                        <Grid>
                          <IconButtonWithConfirmation
                            size="small"
                            onConfirm={() => props.onDelete(item.id)}
                          >
                            <DeleteIcon />
                          </IconButtonWithConfirmation>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                </Draggable>
              ))}
            </DroppableDiv>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
